<template>
    <AppHead title="Submit A Review">
        <meta name="robots" content="noindex, follow"/>
    </AppHead>

    <from-website :website="website">
        <app-title class="capitalize mb-3">Hi {{ user?.name ?? ''}}</app-title>

        <p class="mt-4 text-dark text-lg">
            We're sorry your experience hasn't met your expectations or the high standards we strive to achieve.
        </p>

        <p class="my-4 text-dark text-lg">
            Please can you leave some feedback on what went wrong and what we can do to turn this into a 5 star experience for you.
        </p>

        <p class="my-4 text-dark text-lg">
            This will help us identify any issues and improve our service moving forward.
        </p>

        <create-feedback-form
            :website="website"
            :product="product"
            :request-url="requestUrl"
            :rating="rating"
            :user="user"
            :order-reference="orderReference"
            :fitter-identifier="fitterIdentifier"
            :product-external-identifier="productExternalIdentifier"
            :reasons="reasons"
            :contact="contact"
            :time="time"
        >
        </create-feedback-form>
    </from-website>
</template>

<script>
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import AppNavbar from "@/Components/AppNavbar.vue";
import AppTitle from "@/Components/AppTitle.vue";
import AppButton from "@/Components/AppButton.vue";
import InputError from "@/Components/Forms/Inputs/InputError.vue";
import FromWebsite from "@/Layouts/FromWebsite.vue";
import AppHead from "@/Components/AppSeoTags";
import CreateFeedbackForm from "@/Components/Feedback/Forms/CreateFeedbackForm.vue";

export default {
    layout: null,
    components: {
        AppHead,
        AppTitle,
        AppButton,
        InputError,
        FromWebsite,
        CreateFeedbackForm
    },
    props: {
        product: Object,
        fitterIdentifier: String,
        productExternalIdentifier: String,
        recaptcha: Object,
        website: Object, // The website the user has come from
        user: Object,
        rating: [Number, String],
        orderReference: String,
        reasons: Array,
        contact: Array,
        time: Array
    },
    computed: {
        siteName() {
            return usePage().props.value.config.name;
        },
        requestUrl() {
            return `/websites/${this.website.name}/products/${this.product.identifier}/feedback`;
        }
    },
};
</script>


<style lang="scss" scoped>

</style>
